import React from "react";
import {
  Card,
  CardContent,
  Box,
  Typography,
  Stack,
  Tooltip,
  IconButton,
  Badge,
  useTheme,
} from "@mui/material";
import {
  Refresh as RefreshIcon,
  FilterList as FilterIcon,
  TableChart as TableIcon,
  East as EastIcon,
} from "@mui/icons-material";

const HeaderSection = ({
  totalRecords,
  getVerifiedCount,
  getUnverifiedCount,
  dataLength,
  fetchData,
  showFilters,
  setShowFilters,
  getActiveFiltersCount,
  handleResetFilters,
  isMobile,
  filterFields,
  filters,
  handleFilterChange,
}) => {
  const theme = useTheme();

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography
            variant="h5"
            component="h1"
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
          >
            <TableIcon color="primary" />
            Data Rows Management
          </Typography>

          <Stack direction="row" spacing={1}>
            <Tooltip title="Refresh Data">
              <IconButton onClick={fetchData}>
                <RefreshIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Toggle Filters">
              <IconButton onClick={() => setShowFilters(!showFilters)}>
                <Badge badgeContent={getActiveFiltersCount()} color="primary">
                  <FilterIcon />
                </Badge>
              </IconButton>
            </Tooltip>

            <Tooltip title="Go Back">
              <IconButton
                onClick={() => window.history.back()}
                sx={{
                  border: "1px solid",
                  borderColor: theme.palette.divider,
                  borderRadius: 1,
                }}
              >
                <EastIcon />
              </IconButton>
            </Tooltip>
          </Stack>
        </Box>
      </CardContent>
    </Card>
  );
};

export default HeaderSection;
